import classNames from 'classnames'

import { Label } from 'client/semantic-imports'
import { AppIcon, IconName, ButtonVariant } from 'client/ui-building-blocks'

import styles from './app-chip.module.scss'
import classes from '../classes.module.scss'

type AppChipProps = {
  text?: string
  variant?: ButtonVariant
  iconName?: IconName
  centered?: boolean
  onIconClick?: () => void
}

const AppChip = (props: AppChipProps) => {
  const {
    text = '',
    variant = 'success',
    iconName,
    centered = false,
    onIconClick = null,
  } = props

  return (
    <Label
      data-testid="app-chip"
      className={classNames(styles.appChip, styles[variant], centered && classes.center)}
      content={
        <div className={styles.content}>
          {text ? <div>{text}</div> : null}
          {iconName && (
            <AppIcon
              name={iconName}
              size="small"
              onClick={onIconClick}
              pointer={Boolean(onIconClick)}
            />
          )}
        </div>
      }
    />
  )
}

export default AppChip
